import { log } from 'log';
import { Icon } from 'js/components/common/Icon';
import React, { useCallback, useRef } from 'react';
import { useShowNotification } from 'js/components/common/Notifications';

import * as server from './server';
import { useUpdateFavorites } from './useUpdateFavorites';
import { useFavoritesTracking } from './useFavoritesTracking';

import style from '../FavoriteIcon.scss';

export const getNotification = ({ isFavorite }) => ({
    Icon: <Icon
        type={isFavorite ? 'favorites_added' : 'favorites_removed'}
        className={style.toastIcon}
    />,
    tKey: `playtech.mobile.system.toast.favorites${isFavorite ? 'Add' : 'Remove'}`
});

export const useToggleFavorite = ({ code, isFavorite, gameFeed, translate, setAfterToggleInfo }) => {
    const showNotification = useShowNotification({ displayTime: 2 });
    const updateFavoriteGames = useUpdateFavorites({ code });
    const trackAPIEvent = useFavoritesTracking({ gameCode: code, isFavorite, gameFeed });
    const inProgress = useRef(false);

    return useCallback(() => {
        // prevent double-click
        if (inProgress.current) {
            return;
        }

        inProgress.current = true;

        trackAPIEvent();

        (async () => {
            try {
                const value = !isFavorite;

                await server.changeFavorite({ code, isFavorite: value });
                showNotification(getNotification({ isFavorite: value }));
                setAfterToggleInfo(value ? translate('added.successfully') : translate('removed.successfully'));
                updateFavoriteGames(value);
            } catch (error) {
                log('error', error);
            } finally {
                inProgress.current = false;
            }
        })();
    }, [
        inProgress, updateFavoriteGames, code, translate,
        isFavorite, showNotification, trackAPIEvent, setAfterToggleInfo
    ]);
};
